import React, {
    useEffect,
    useRef,
    useState
} from "react";

import {
    ArrowLeftOutlined,
    CompressOutlined,
    ExpandOutlined,
    ReloadOutlined
} from "@ant-design/icons";

import {
    useNavigate
} from "react-router-dom";

import {
    renderAsync
} from "docx-preview";

import {
    getDocxReaderBuffer,
    getReaderFolder,
    getReaderChildFolder,
    getReaderFolderFileBlob
} from "../api/myBook";


export default function DocxLabView({
    slug,
    title
}) {

    const navigate =
        useNavigate();

    const contentRef =
        useRef(null);

    const wrapperRef =
        useRef(null);

    const [loading, setLoading] =
        useState(true);

    const [error, setError] =
        useState("");

    const [reloadKey, setReloadKey] =
        useState(0);

    const [fullscreen, setFullscreen] =
        useState(false);

    const [internalPdfUrl, setInternalPdfUrl] =
        useState("");

    const [internalPdfName, setInternalPdfName] =
        useState("");

    const [folderFiles, setFolderFiles] =
        useState([]);

    const [folderHistory, setFolderHistory] =
        useState([]);

    const [folderLoading, setFolderLoading] =
        useState(false);

    const [pdfLoadingName, setPdfLoadingName] =
        useState("");

    const [pdfLoadingSize, setPdfLoadingSize] =
        useState(null);


    useEffect(() => {

        const onFullscreen =
            () =>
                setFullscreen(
                    Boolean(
                        document.fullscreenElement
                    )
                );

        document.addEventListener(
            "fullscreenchange",
            onFullscreen
        );

        return () =>
            document.removeEventListener(
                "fullscreenchange",
                onFullscreen
            );

    }, []);


    useEffect(() => {

        let alive =
            true;

        const load =
            async () => {

                try {

                    setLoading(true);
                    setError("");

                    const result =
                        await getDocxReaderBuffer(
                            slug
                        );

                    if (!alive) {
                        return;
                    }

                    const type =
                        String(
                            result.contentType ||
                            ""
                        ).toLowerCase();

                    if (
                        !type.includes(
                            "wordprocessingml"
                        ) &&
                        !type.includes(
                            "application/octet-stream"
                        )
                    ) {
                        throw new Error(
                            "File này không phải DOCX. Content-Type: " +
                            type
                        );
                    }

                    if (
                        !contentRef.current
                    ) {
                        return;
                    }

                    contentRef.current.innerHTML =
                        "";

                    await renderAsync(
                        result.data,
                        contentRef.current,
                        null,
                        {
                            className:
                                "docx",

                            inWrapper:
                                true,

                            breakPages:
                                true,

                            ignoreWidth:
                                false,

                            ignoreHeight:
                                false,

                            ignoreFonts:
                                false,

                            useBase64URL:
                                true
                        }
                    );


                    const links =
                        contentRef.current
                            .querySelectorAll(
                                "a"
                            );

                    links.forEach(
                        link => {

                            const href =
                                String(
                                    link.getAttribute(
                                        "href"
                                    ) || ""
                                );

                            const isDriveFolder =
                                /drive\.google\.com\/(?:drive\/)?folders\//i
                                    .test(
                                        href
                                    );

                            /*
                             * Link Drive Folder:
                             * GIU BAM DUOC, nhung mo noi bo.
                             */
                            if (
                                isDriveFolder
                            ) {

                                link.removeAttribute(
                                    "target"
                                );

                                link.style.pointerEvents =
                                    "auto";

                                link.style.cursor =
                                    "pointer";

                                link.addEventListener(
                                    "click",
                                    async event => {

                                        event.preventDefault();
                                        event.stopPropagation();

                                        try {

                                            setFolderLoading(
                                                true
                                            );

                                            const result =
                                                await getReaderFolder(
                                                    slug,
                                                    href
                                                );

                                            const files =
                                                result?.data?.files ||
                                                [];

                                            if (
                                                files.length === 0
                                            ) {
                                                throw new Error(
                                                    "Không tìm thấy PDF trong thư mục."
                                                );
                                            }


                                            setFolderFiles(
                                                files
                                            );

                                        } catch (error) {

                                            console.error(
                                                "FOLDER LINK ERROR:",
                                                error
                                            );

                                            alert(
                                                error?.response
                                                    ?.data
                                                    ?.message ||
                                                error?.message ||
                                                "Không mở được tài liệu."
                                            );

                                        } finally {

                                            setFolderLoading(
                                                false
                                            );
                                        }
                                    }
                                );

                                return;
                            }

                            /*
                             * Link ngoai khac van bi vo hieu hoa,
                             * tranh day khach khoi OS BOOKS.
                             */
                            link.removeAttribute(
                                "href"
                            );

                            link.removeAttribute(
                                "target"
                            );

                            link.style.pointerEvents =
                                "none";

                            link.style.cursor =
                                "default";
                        }
                    );

                    /*
                     * FALLBACK:
                     * Một số DOCX được docx-preview render hyperlink
                     * thành span/text thay vì thẻ <a>.
                     *
                     * Vì vậy tìm phần tử có chữ "XEM NGAY"
                     * và gắn thao tác mở tài liệu nội bộ.
                     */
                    const normalizedText =
                        value =>
                            String(value || "")
                                .replace(/\s+/g, " ")
                                .trim()
                                .toUpperCase();

                    const candidates =
                        Array.from(
                            contentRef.current
                                .querySelectorAll(
                                    "span,p,div"
                                )
                        )
                            .filter(
                                element =>
                                    normalizedText(
                                        element.textContent
                                    ) ===
                                    "XEM NGAY"
                            );

                    const openInternalFolder =
                        async () => {

                            try {

                                setFolderLoading(
                                    true
                                );

                                /*
                                 * docx-preview co the render chu XEM NGAY
                                 * thanh span thay vi <a>.
                                 *
                                 * Khong hard-code folder.
                                 * Tim link Drive Folder THUC cua chinh
                                 * tai lieu DOCX dang mo.
                                 */
                                const allElements =
                                    Array.from(
                                        contentRef.current
                                            ?.querySelectorAll(
                                                "*"
                                            ) || []
                                    );

                                const driveFolderHref =
                                    allElements
                                        .map(
                                            element =>
                                                String(
                                                    element.getAttribute?.(
                                                        "href"
                                                    ) ||
                                                    element.getAttribute?.(
                                                        "data-href"
                                                    ) ||
                                                    element.getAttribute?.(
                                                        "data-url"
                                                    ) ||
                                                    ""
                                                )
                                        )
                                        .find(
                                            value =>
                                                /drive\.google\.com\/(?:drive\/)?folders\//i
                                                    .test(
                                                        value
                                                    )
                                        ) ||
                                    Array.from(
                                        contentRef.current
                                            ?.querySelectorAll(
                                                "a"
                                            ) || []
                                    )
                                        .map(
                                            element =>
                                                String(
                                                    element.href ||
                                                    ""
                                                )
                                        )
                                        .find(
                                            value =>
                                                /drive\.google\.com\/(?:drive\/)?folders\//i
                                                    .test(
                                                        value
                                                    )
                                        );

                                if (
                                    !driveFolderHref
                                ) {
                                    throw new Error(
                                        "Không tìm thấy liên kết thư mục của tài liệu này."
                                    );
                                }

                                const result =
                                    await getReaderFolder(
                                        slug,
                                        driveFolderHref
                                    );

                                const files =
                                    result?.data?.files ||
                                    [];

                                if (
                                    files.length === 0
                                ) {
                                    throw new Error(
                                        "Không tìm thấy PDF trong thư mục."
                                    );
                                }


                                setFolderFiles(
                                    files
                                );

                            } catch (error) {

                                console.error(
                                    "XEM NGAY INTERNAL ERROR:",
                                    error
                                );

                                alert(
                                    error?.response
                                        ?.data
                                        ?.message ||
                                    error?.message ||
                                    "Không mở được tài liệu."
                                );

                            } finally {

                                setFolderLoading(
                                    false
                                );
                            }
                        };

                    candidates.forEach(
                        element => {

                            element.style.cursor =
                                "pointer";

                            element.style.pointerEvents =
                                "auto";

                            element.setAttribute(
                                "role",
                                "button"
                            );

                            element.setAttribute(
                                "tabindex",
                                "0"
                            );

                            element.onclick =
                                event => {

                                    event.preventDefault();
                                    event.stopPropagation();

                                    openInternalFolder();
                                };

                            element.onkeydown =
                                event => {

                                    if (
                                        event.key ===
                                            "Enter" ||
                                        event.key ===
                                            " "
                                    ) {
                                        event.preventDefault();

                                        openInternalFolder();
                                    }
                                };
                        }
                    );

                    console.log(
                        "XEM NGAY clickable elements:",
                        candidates.length
                    );

                    if (alive) {
                        setLoading(false);
                    }

                } catch (err) {

                    console.error(
                        "DOCX LAB ERROR:",
                        err
                    );

                    if (alive) {

                        setLoading(false);

                        setError(
                            err?.message ||
                            "Không thể mở DOCX."
                        );
                    }
                }
            };

        load();

        return () => {
            alive =
                false;
        };

    }, [
        slug,
        reloadKey
    ]);


    const toggleFullscreen =
        async () => {

            try {

                if (
                    document.fullscreenElement
                ) {
                    await document
                        .exitFullscreen();

                    return;
                }

                if (
                    wrapperRef.current
                        ?.requestFullscreen
                ) {
                    await wrapperRef
                        .current
                        .requestFullscreen();
                }

            } catch (err) {

                console.log(
                    "Fullscreen error:",
                    err
                );
            }
        };


    if (
        internalPdfUrl
    ) {
        return (
            <div
                className="
                    fixed
                    inset-0
                    z-[100000]
                    flex
                    flex-col
                    bg-[#202124]
                "
            >
                <div
                    className="
                        h-[58px]
                        flex-none
                        flex
                        items-center
                        gap-3
                        px-4
                        bg-[#17191c]
                        text-white
                        border-b
                        border-white/10
                    "
                >
                    <button
                        type="button"
                        onClick={() => {
                            if (
                                internalPdfUrl &&
                                internalPdfUrl.startsWith(
                                    "blob:"
                                )
                            ) {
                                URL.revokeObjectURL(
                                    internalPdfUrl
                                );
                            }

                            setInternalPdfUrl(
                                ""
                            );

                            setInternalPdfName(
                                ""
                            );

                            /*
                             * folderFiles van con nguyen,
                             * nen popup danh sach tai lieu
                             * se hien lai ngay.
                             */
                        }}
                        className="
                            px-3
                            h-9
                            rounded-lg
                            hover:bg-white/10
                            font-semibold
                        "
                    >
                        ← TÀI LIỆU
                    </button>

                    <div
                        className="
                            flex-1
                            truncate
                            font-semibold
                        "
                    >
                        {internalPdfName}
                    </div>
                </div>

                <div
                    className="
                        relative
                        flex-1
                        min-h-0
                        bg-[#202124]
                    "
                >
                    <iframe
                        src={internalPdfUrl}
                        title={
                            internalPdfName ||
                            "PDF"
                        }
                        className="
                            absolute
                            inset-0
                            w-full
                            h-full
                            border-0
                            bg-[#202124]
                        "
                    />

                    {/*
                      Che cac nut:
                      Add to Drive / Download / Print / More
                      cua PDF Viewer trinh duyet.
                    */}
                    <div
                        className="
                            osbooks-pdf-toolbar-mask
                            absolute
                            top-0
                            right-0
                            z-[60]
                            h-[56px]
                            w-[178px]
                            bg-[#3c3c3c]
                        "
                        aria-hidden="true"
                    />
                </div>
            </div>
        );
    }


    return (

        <div
            ref={wrapperRef}
            className="
                fixed
                inset-0
                z-[99999]
                flex
                flex-col
                bg-[#202124]
            "
        >

            <header
                className="
                    h-[58px]
                    flex-none
                    flex
                    items-center
                    gap-2
                    px-3
                    md:px-4
                    bg-[#17191c]
                    border-b
                    border-white/10
                    text-white
                "
            >

                <button
                    type="button"
                    onClick={() =>
                        navigate(-1)
                    }
                    className="
                        h-9
                        px-3
                        rounded-lg
                        flex
                        items-center
                        gap-2
                        hover:bg-white/10
                    "
                >
                    <ArrowLeftOutlined />

                    <span
                        className="
                            hidden
                            sm:inline
                            font-semibold
                            text-sm
                        "
                    >
                        THƯ VIỆN
                    </span>
                </button>


                <div
                    className="
                        flex-1
                        min-w-0
                    "
                >

                    <div
                        className="
                            truncate
                            font-semibold
                            text-sm
                            md:text-[15px]
                        "
                    >
                        {title ||
                            "Tài liệu"}
                    </div>

                    <div
                        className="
                            hidden
                            sm:block
                            text-[10px]
                            text-gray-400
                        "
                    >
                        Đang đọc trực tuyến
                    </div>

                </div>


                <button
                    type="button"
                    onClick={() =>
                        setReloadKey(
                            value =>
                                value + 1
                        )
                    }
                    className="
                        w-9
                        h-9
                        rounded-lg
                        hover:bg-white/10
                    "
                    title="Tải lại"
                >
                    <ReloadOutlined />
                </button>


                <button
                    type="button"
                    onClick={
                        toggleFullscreen
                    }
                    className="
                        w-9
                        h-9
                        rounded-lg
                        hover:bg-white/10
                    "
                    title="Toàn màn hình"
                >
                    {fullscreen
                        ? <CompressOutlined />
                        : <ExpandOutlined />
                    }
                </button>

            </header>


            <main
                className="
                    relative
                    flex-1
                    min-h-0
                    overflow-auto
                    bg-[#303030]
                    py-5
                    px-2
                    md:px-5
                "
            >

                {loading && (

                    <div
                        className="
                            fixed
                            inset-0
                            top-[58px]
                            z-20
                            flex
                            items-center
                            justify-center
                            bg-[#202124]
                            text-gray-300
                        "
                    >
                        Đang mở tài liệu DOCX...
                    </div>
                )}


                {folderLoading && (
                    <div
                        className="
                            fixed
                            inset-0
                            z-[100001]
                            flex
                            items-center
                            justify-center
                            bg-black/75
                            backdrop-blur-sm
                            text-white
                            p-5
                        "
                    >
                        <div
                            className="
                                w-full
                                max-w-[420px]
                                rounded-2xl
                                bg-[#202124]
                                border
                                border-white/10
                                shadow-2xl
                                px-6
                                py-7
                                text-center
                            "
                        >
                            <div
                                className="
                                    mx-auto
                                    w-10
                                    h-10
                                    rounded-full
                                    border-4
                                    border-white/20
                                    border-t-white
                                    animate-spin
                                "
                            />

                            <div
                                className="
                                    mt-5
                                    text-lg
                                    font-semibold
                                "
                            >
                                {pdfLoadingName
                                    ? "Đang tải tài liệu..."
                                    : "Đang mở thư mục tài liệu..."
                                }
                            </div>

                            {pdfLoadingName && (
                                <div
                                    className="
                                        mt-2
                                        text-sm
                                        text-gray-300
                                        break-words
                                    "
                                >
                                    {pdfLoadingName}
                                </div>
                            )}

                            {pdfLoadingSize && (
                                <div
                                    className="
                                        mt-1
                                        text-xs
                                        text-gray-400
                                    "
                                >
                                    Dung lượng khoảng{" "}
                                    {(
                                        Number(
                                            pdfLoadingSize
                                        ) /
                                        1024 /
                                        1024
                                    ).toFixed(1)}
                                    {" MB"}
                                </div>
                            )}

                            <div
                                className="
                                    mt-4
                                    text-xs
                                    text-gray-400
                                "
                            >
                                Vui lòng chờ trong khi hệ thống chuẩn bị tài liệu.
                            </div>
                        </div>
                    </div>
                )}


                {folderFiles.length > 0 && (
                    <div
                        className="
                            fixed
                            inset-0
                            z-40
                            flex
                            items-center
                            justify-center
                            bg-black/70
                            p-4
                        "
                    >
                        <div
                            className="
                                w-full
                                max-w-[560px]
                                max-h-[75vh]
                                overflow-auto
                                rounded-2xl
                                bg-white
                                p-5
                                shadow-2xl
                            "
                        >
                            <div
                                className="
                                    text-lg
                                    font-semibold
                                "
                            >
                                Tài liệu trong thư mục
                            </div>

                            {folderHistory.length > 0 && (
                                <button
                                    type="button"
                                    onClick={() => {
                                        const previous =
                                            folderHistory[
                                                folderHistory.length - 1
                                            ];

                                        setFolderFiles(
                                            previous.files
                                        );

                                        setFolderHistory(
                                            history =>
                                                history.slice(
                                                    0,
                                                    -1
                                                )
                                        );
                                    }}
                                    className="
                                        mt-3
                                        inline-flex
                                        items-center
                                        gap-2
                                        rounded-lg
                                        bg-gray-100
                                        px-3
                                        py-2
                                        text-sm
                                        font-medium
                                        text-gray-700
                                        hover:bg-gray-200
                                    "
                                >
                                    ← Thư mục trước
                                </button>
                            )}

                            <div
                                className="
                                    mt-4
                                    space-y-2
                                "
                            >
                                {folderFiles.map(
                                    file => (
                                        <button
                                            key={
                                                file.id
                                            }
                                            type="button"
                                            onClick={
                                                async () => {

                                                    if (
                                                        file.type ===
                                                        "folder"
                                                    ) {
                                                        try {
                                                            setFolderLoading(
                                                                true
                                                            );

                                                            const result =
                                                                await getReaderChildFolder(
                                                                    slug,
                                                                    file.id,
                                                                    file.parentFolderId
                                                                );

                                                            const children =
                                                                result?.data
                                                                    ?.data
                                                                    ?.files ||
                                                                [];

                                                            setFolderHistory(
                                                                history => [
                                                                    ...history,
                                                                    {
                                                                        files:
                                                                            folderFiles,
                                                                        name:
                                                                            file.name
                                                                    }
                                                                ]
                                                            );

                                                            setFolderFiles(
                                                                children
                                                            );

                                                        } catch (error) {

                                                            console.error(
                                                                "CHILD FOLDER ERROR:",
                                                                error
                                                            );

                                                            alert(
                                                                error?.response
                                                                    ?.data
                                                                    ?.message ||
                                                                error?.message ||
                                                                "Không mở được thư mục."
                                                            );

                                                        } finally {

                                                            setFolderLoading(
                                                                false
                                                            );
                                                        }

                                                        return;
                                                    }

                                                    try {

                                                        setFolderLoading(
                                                            true
                                                        );

                                                        setPdfLoadingName(
                                                            file.name ||
                                                            "Tài liệu PDF"
                                                        );

                                                        setPdfLoadingSize(
                                                            file.size ||
                                                            null
                                                        );

                                                        const blob =
                                                            await getReaderFolderFileBlob(
                                                                file.url
                                                            );

                                                        const objectUrl =
                                                            URL.createObjectURL(
                                                                blob
                                                            );

                                                        setInternalPdfName(
                                                            file.name
                                                        );

                                                        setInternalPdfUrl(
                                                            objectUrl
                                                        );

                                                        /*
                                                         * KHONG xoa folderFiles/folderHistory.
                                                         * Khi dong PDF se quay lai dung
                                                         * danh sach tai lieu vua chon.
                                                         */

                                                    } catch (error) {

                                                        console.error(
                                                            "PDF LOAD ERROR:",
                                                            error
                                                        );

                                                        alert(
                                                            error?.response
                                                                ?.data
                                                                ?.message ||
                                                            error?.message ||
                                                            "Không tải được tài liệu."
                                                        );

                                                    } finally {

                                                        setFolderLoading(
                                                            false
                                                        );

                                                        setPdfLoadingName(
                                                            ""
                                                        );

                                                        setPdfLoadingSize(
                                                            null
                                                        );
                                                    }
                                                }
                                            }
                                            className="
                                                flex
                                                items-center
                                                gap-3
                                                w-full
                                                rounded-xl
                                                border
                                                border-gray-200
                                                p-4
                                                text-left
                                                hover:bg-gray-50
                                            "
                                        >
                                            <span
                                                className="
                                                    text-2xl
                                                    flex-none
                                                "
                                            >
                                                {file.type ===
                                                "folder"
                                                    ? "📁"
                                                    : "📄"}
                                            </span>

                                            <span
                                                className="
                                                    min-w-0
                                                    flex-1
                                                "
                                            >
                                                <span
                                                    className="
                                                        block
                                                        truncate
                                                        font-medium
                                                        text-gray-800
                                                    "
                                                >
                                                    {file.name}
                                                </span>

                                                {file.type ===
                                                "pdf" &&
                                                file.size && (
                                                    <span
                                                        className="
                                                            block
                                                            mt-1
                                                            text-xs
                                                            text-gray-400
                                                        "
                                                    >
                                                        {(
                                                            Number(
                                                                file.size
                                                            ) /
                                                            1024 /
                                                            1024
                                                        ).toFixed(1)}
                                                        {" MB"}
                                                    </span>
                                                )}
                                            </span>

                                            {file.type ===
                                            "folder" && (
                                                <span
                                                    className="
                                                        text-gray-400
                                                        text-xl
                                                    "
                                                >
                                                    ›
                                                </span>
                                            )}
                                        </button>
                                    )
                                )}
                            </div>

                            <button
                                type="button"
                                onClick={() => {
                                    setFolderFiles(
                                        []
                                    );

                                    setFolderHistory(
                                        []
                                    );
                                }}
                                className="
                                    mt-4
                                    rounded-lg
                                    px-4
                                    py-2
                                    bg-gray-100
                                "
                            >
                                Đóng
                            </button>
                        </div>
                    </div>
                )}


                {error && (

                    <div
                        className="
                            mx-auto
                            mt-14
                            max-w-[560px]
                            rounded-xl
                            bg-white
                            p-6
                            shadow-xl
                        "
                    >

                        <div
                            className="
                                text-lg
                                font-semibold
                                text-red-600
                        "
                        >
                            Không mở được tài liệu
                        </div>

                        <div
                            className="
                                mt-3
                                text-sm
                                text-gray-600
                            "
                        >
                            {error}
                        </div>

                    </div>
                )}


                <div
                    ref={contentRef}
                    className="
                        os-docx-reader
                        mx-auto
                    "
                />

            </main>


            <style>
                {`
                .os-docx-reader .docx-wrapper {
                    background: transparent !important;
                    padding: 0 !important;
                }

                .os-docx-reader .docx-wrapper > section.docx {
                    margin: 0 auto 20px !important;
                    box-shadow:
                        0 8px 30px rgba(0,0,0,.32);
                }

                .os-docx-reader a {
                    pointer-events: none !important;
                    cursor: default !important;
                    text-decoration: none !important;
                    color: inherit !important;
                }
                `}
            </style>

        </div>
    );
}
